import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-8">
          <div className="wordmark text-4xl">DAD</div>
          <div className="wordmark-sub text-[10px] mt-1.5">COMPANY BRAIN</div>
        </div>
        <div className="glass rounded-3xl p-8">
          {done ? (
            <div data-testid="forgot-confirmation" className="text-center space-y-4">
              <p className="text-gray-300 text-sm">Se l'email è registrata, è stato inviato un link di reimpostazione.</p>
              <Link to="/login" data-testid="forgot-back-link" className="btn-ghost inline-flex">Torna all'accesso</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <h1 className="font-display font-bold text-lg">Reimposta la password</h1>
              <input data-testid="forgot-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="input-dark" placeholder="nome@azienda.ch" />
              {error && <div className="text-sm text-red-400">{error}</div>}
              <button data-testid="forgot-submit" type="submit" className="btn-primary w-full">Invia link di reimpostazione</button>
              <div className="text-center">
                <Link to="/login" className="text-xs text-gray-500 hover:text-cyan-300">Torna all'accesso</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
